/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Paths_Download_DescInputs */

const en_fc_home_paths_download_desc = /** @type {(inputs: Fc_Home_Paths_Download_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Official download links and English installation steps for macOS, Windows and Linux.`)
};

/**
* | output |
* | --- |
* | "Official download links and English installation steps for macOS, Windows and Linux." |
*
* @param {Fc_Home_Paths_Download_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_paths_download_desc = /** @type {((inputs?: Fc_Home_Paths_Download_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Paths_Download_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_paths_download_desc(inputs)
});
export { fc_home_paths_download_desc as "fc.home.paths.download.desc" }